import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import { AppReleaseVersion } from "stores/lib";

import { FOTS } from "utility/typescript";

// -----------------------------------------------------------------------------

const ThingsToIgnore: string[] = [];

// -----------------------------------------------------------------------------

if (!process.env.REACT_APP_NO_SENTRY && !process.env.REACT_APP_NO_EXTERNAL) {
  console.log("API_URL", process.env.REACT_APP_API_SITE_URL);
  Sentry.init({
    dsn: "https://5539f04a79764cb1b23d549c74d271e7@o531054.ingest.sentry.io/5651272",
    debug: process.env.REACT_APP_ENVIRONMENT !== "production",
    integrations: [
      new Integrations.BrowserTracing({
        tracePropagationTargets: [
          "localhost",
          /^\//,
          "api.threatkey.com",
          "api-dev.svc.threatkey.com",
        ],
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }) as FOTS,
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false,
        maskTextSelector: "lipsum",
        stickySession: true,
      }),
    ],
    beforeSend: (event, hint) =>
      process.env.REACT_APP_NO_SENTRY
        ? localErrorOnly(
            event?.transaction ?? "Unknown transaction",
            hint.originalException ??
              hint.syntheticException ??
              new Error("An error occurred")
          )
        : event,
    ignoreErrors: ThingsToIgnore,
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: AppReleaseVersion,
    attachStacktrace: true,
    autoSessionTracking: true,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0, // consider reducing to 10% in production
    replaysOnErrorSampleRate: 1.0,
  });
} else {
  console.info("Sentry disabled");
}

// -----------------------------------------------------------------------------

function localErrorOnly(message: string, error: unknown): null {
  console.error(`${message}:\n`, error);

  //
  return null;
}
